import { apiConfig } from 'core-lib/config/config';
import { postMethod } from 'core-lib/utils/apiV2';
import { getDefaultHeaders } from 'core-lib/utils/network';

const postUserReview = async (data) => {
  const endPoint = `${apiConfig('magento')}/default/V1/custom/review`;

  const body = {
    review: data,
  };

  const { response, error }: any = await postMethod({
    endPoint,
    body,
    headers: getDefaultHeaders({ deviceId: true }),
  });

  if (response) {
    return { response };
  } else {
    return { error };
  }
};

export default postUserReview;
